


































































import { ErrorPageError } from '~/models/error'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import ClassifiedService from '~/services/classified/ClassifiedService'
import { Classified } from '~/models/classified/types'
import FeedGrid from '~/components/car/classifieds/index/feeds/FeedGrid.vue'
import { formatNumber } from '~/utils/number'
import { SimilarClassifiedsEntity } from '~/models/classified/view/similar'
import { DeletedInfoLink } from '~/models/classified/view/deleted'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import { BackendMetaItem } from '~/models/head/types'
import { defineComponentTranslations } from '~/utils/i18n'
import CGradientBorderContainer from '~/components/shared/configurable/CGradientBorderContainer.vue'

interface Data {
  relatedLinks: DeletedInfoLink[]
  classified: Classified | null
  page: any
  similar: SimilarClassifiedsEntity
  seenByOthers: SimilarClassifiedsEntity
}

export default defineComponent({
  components: {
    CShimmer,
    CBadge,
    FeedGrid,
    CBreadcrumbs,
    CGradientBorderContainer
  },
  props: {
    error: {
      type: Object as PropType<ErrorPageError>,
      required: true
    }
  },
  data(): Data {
    return {
      relatedLinks: [],
      classified: null,
      page: null,
      similar: null,
      seenByOthers: null,
      loading: true
    }
  },
  computed: {
    classifiedId() {
      return this.error.meta.classifiedId
    }
  },
  async mounted() {
    const classifiedService = this.$dep(ClassifiedService)

    try {
      const [deletedInfoData, similarClassifiedsData] = await Promise.all([
        classifiedService.getDeletedInfo(this.classifiedId),
        classifiedService.getSimilarClassifieds(this.classifiedId, true)
      ])

      this.relatedLinks = deletedInfoData.relatedLinks
      this.classified = deletedInfoData.classified
      this.page = deletedInfoData.page

      this.similar = similarClassifiedsData.similar
      this.seenByOthers = similarClassifiedsData.seenByOthers
    } catch (error) {
    } finally {
      this.loading = false
    }
  },
  methods: {
    formatNumber,
    showSimilarEntryFeed(similarEntry: SimilarClassifiedsEntity) {
      return (
        similarEntry &&
        similarEntry.classifieds &&
        similarEntry.classifieds.length > 0
      )
    }
  },
  head() {
    if (!this.page) {
      return
    }
    const { title, metadata } = this.page

    return {
      title,
      meta: metadata.map((metaItem: BackendMetaItem) => ({
        ...metaItem,
        hid: metaItem.name || metaItem.property
      }))
    }
  },
  i18n: defineComponentTranslations({
    select_one_of_the_suggested_searches_to_find_what_you_are_looking_for: {
      en:
        'Select one of the suggested searches to find what you are looking for.',
      el:
        'Επίλεξε κάποια από τις προτεινόμενες αναζητήσεις για να βρεις αυτό που ψάχνεις.'
    },
    suggested_searches: {
      en: 'Suggested searches',
      el: 'Προτεινόμενες αναζητήσεις'
    }
  })
})
